// File: assets/ai-widget.js
// Version 4.1: Corrected a critical error where helper function bodies were empty. Functionality is now fully restored.

document.addEventListener('DOMContentLoaded', function() {
  const MAKE_COM_WEBHOOK_URL = 'https://hook.eu1.make.com/4m1dj5acwbywh9lmst76kab6w0bockeg';
  const GENERATION_LIMIT_PER_DAY = 3;
  const localStorageKey = 'aiFabulousPortrait';

  const widgetContainer = document.getElementById('ai-preview-widget-container');
  if (!widgetContainer) return;

  // --- Element Selectors ---
  const fileInput = document.getElementById('aiFileInput');
  const customUploadBtn = document.getElementById('aiCustomUploadBtn');
  const fileNameDisplay = document.getElementById('aiFileName');
  const styleSelector = document.getElementById('aiStyleSelector');
  const aspectRatioRadios = document.querySelectorAll('input[name="aspect_ratio"]');
  const generateBtn = document.getElementById('aiGenerateBtn');
  const loader = document.getElementById('aiLoader');
  const errorMessage = document.getElementById('aiErrorMessage');
  const previewArea = document.getElementById('aiPreviewArea');
  const previewImage = document.getElementById('aiPreviewImage');
  const creditCounter = document.getElementById('aiCreditCounter');
  const addToCartBtn = document.getElementById('ProductSubmitButton-template--25584240984396__main');
  
  let previewGenerated = false;

  // --- Core Functions ---
  function disableATCButton() {
    if (addToCartBtn && !addToCartBtn.disabled) {
      addToCartBtn.disabled = true;
    }
  }

  function enableATCButton() {
    if (addToCartBtn && addToCartBtn.disabled) {
      addToCartBtn.disabled = false;
    }
  }

  function resetOnInputChange() {
    if (previewGenerated) {
      previewArea.style.display = 'none';
      previewImage.src = '';
      if (checkGenerationLimit()) {
        generateBtn.textContent = 'Generate AI Preview';
        generateBtn.disabled = false;
      }
      previewGenerated = false;
    }
    disableATCButton();
  }

  // --- Helper functions for daily limit (NOW CORRECTLY FILLED) ---
  const updateCreditDisplay = () => {
    const data = JSON.parse(localStorage.getItem(localStorageKey));
    let count = 0;
    if (data && (new Date().getTime() - data.timestamp < 86400000)) {
      count = data.count;
    }
    const remaining = GENERATION_LIMIT_PER_DAY - count;
    if (remaining <= 0) {
      creditCounter.textContent = "You have no previews left for today.";
    } else if (remaining === 1) {
      creditCounter.textContent = "You have 1 preview remaining today.";
    } else {
      creditCounter.textContent = `You have ${remaining} previews remaining today.`;
    }
  };

  const checkGenerationLimit = () => {
    const data = JSON.parse(localStorage.getItem(localStorageKey));
    const now = new Date().getTime();
    if (data) {
      if (now - data.timestamp > 86400000) {
        localStorage.removeItem(localStorageKey);
        return true;
      }
      if (data.count >= GENERATION_LIMIT_PER_DAY) {
        showError(`You have reached the daily limit of ${GENERATION_LIMIT_PER_DAY} previews. Please try again tomorrow.`);
        generateBtn.disabled = true;
        generateBtn.textContent = 'Daily Limit Reached';
        return false;
      }
    }
    return true;
  };

  const incrementGenerationCount = () => {
    let data = JSON.parse(localStorage.getItem(localStorageKey));
    const now = new Date().getTime();
    if (data && (now - data.timestamp < 86400000)) {
      data.count++;
      data.timestamp = now;
    } else {
      data = { count: 1, timestamp: now };
    }
    localStorage.setItem(localStorageKey, JSON.stringify(data));
  };

  const showError = (message) => {
    errorMessage.textContent = message;
    errorMessage.style.display = 'block';
  };

  const clearError = () => {
    errorMessage.style.display = 'none';
  };


  // --- Main Logic for AI Generation ---
  async function handleGenerateClick() {
    clearError();
    if (!checkGenerationLimit()) return;

    const selectedFile = fileInput.files[0];
    const selectedStyle = styleSelector.value;
    const selectedAspectRatio = document.querySelector('input[name="aspect_ratio"]:checked').value;

    if (!selectedFile) { showError('Please upload a photo first.'); return; }
    if (!selectedStyle) { showError('Please select a style.'); return; }
    
    generateBtn.disabled = true;
    generateBtn.textContent = 'Generating...';
    loader.style.display = 'block';
    previewArea.style.display = 'none';
    disableATCButton();

    try {
      // Reverted to the explicit FormData append method for clarity and robustness
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('style', selectedStyle);
      formData.append('aspect_ratio', selectedAspectRatio);

      const response = await fetch(MAKE_COM_WEBHOOK_URL, { method: 'POST', body: formData });
      const result = await response.json();

      if (!response.ok || !result.secure_url) {
        throw new Error(result.message || 'The AI generation failed. Please try again.');
      }
      
      incrementGenerationCount();
      updatePreviewAndProperties(result.secure_url, selectedStyle, selectedAspectRatio);

    } catch (error) {
      showError(`An error occurred: ${error.message}`);
      if (checkGenerationLimit()) {
        generateBtn.disabled = false;
        generateBtn.textContent = 'Generate AI Preview';
      }
    } finally {
      loader.style.display = 'none';
    }
  }
  
  function updatePreviewAndProperties(aiImageUrl, style, aspectRatio) {
    previewImage.src = aiImageUrl;
    previewArea.style.display = 'block';

    document.getElementById('aiGeneratedImageProperty').value = aiImageUrl;
    document.getElementById('aiStyleProperty').value = style;
    document.getElementById('aspectRatioProperty').value = aspectRatio;
    
    // The file input name is now set in the HTML, no need to change it here.
    customUploadBtn.style.display = 'none';
    fileNameDisplay.textContent = `${fileInput.files[0].name}`;
    fileNameDisplay.style.fontStyle = 'normal';
    fileNameDisplay.style.color = '#008000';
    generateBtn.textContent = 'Regenerate Preview';
    generateBtn.disabled = false; // Allow regeneration
    
    updateCreditDisplay();
    checkGenerationLimit();
    
    enableATCButton(); // ONLY here is the button enabled
    previewGenerated = true;
  }

  // --- THE BULLETPROOF FIX: MutationObserver ---
  if (addToCartBtn) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
          if (!addToCartBtn.disabled && !previewGenerated) {
            setTimeout(() => disableATCButton(), 0);
          }
        }
      }
    });
    observer.observe(addToCartBtn, { attributes: true });
  } else {
    console.error("AI Widget Error: Could not find the Add to Cart button.");
  }

  // --- Initial Setup & Event Listeners ---
  disableATCButton();
  updateCreditDisplay();
  checkGenerationLimit();

  // This listener MUST be here and correct
  customUploadBtn.addEventListener('click', () => fileInput.click());
  
  generateBtn.addEventListener('click', handleGenerateClick);

  fileInput.addEventListener('change', () => {
    fileNameDisplay.textContent = fileInput.files.length > 0 ? fileInput.files[0].name : 'No file chosen';
    resetOnInputChange();
  });
  styleSelector.addEventListener('change', resetOnInputChange);
  aspectRatioRadios.forEach(radio => radio.addEventListener('change', resetOnInputChange));
});